import { createFileRoute, lazyRouteComponent, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/settings_/carriers/$carrierId/sites')({
  beforeLoad: ({ context, params }): void => {
    if (
      context.permissions.isReady &&
      !context.permissions.hasAnyPermission(['carriers:manage', 'carriers:access-read-only'])
    ) {
      throw redirect({ params: { carrierId: params.carrierId }, to: '/settings/carriers/$carrierId' });
    }
  },
  component: lazyRouteComponent(() =>
    import('&/features/settings/carriers/pages/carrier-enabled-sites-page').then((m) => ({
      default: m.CarrierEnabledSitesPage,
    })),
  ),
});
